import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PatientQueue } from "./PatientQueue";
import { useAuthStore } from "@/lib/auth";
import { Clock, CheckCircle2, Stethoscope } from "lucide-react";
import { Patient } from "@/types";

interface StatusTabsProps {
  filteredPatients?: Patient[];
}

export function StatusTabs({ filteredPatients }: StatusTabsProps) {
  const { user } = useAuthStore();
  const isDoctor = user?.role === 'doctor';

  if (isDoctor) {
    return (
      <Tabs defaultValue="in-consultation" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="in-consultation" className="flex items-center gap-2">
            <Stethoscope className="h-4 w-4" />
            In Consultation
          </TabsTrigger>
          <TabsTrigger value="completed" className="flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4" />
            Completed
          </TabsTrigger>
        </TabsList>
        <TabsContent value="in-consultation">
          <PatientQueue status="in-consultation" filteredPatients={filteredPatients} />
        </TabsContent>
        <TabsContent value="completed">
          <PatientQueue status="completed" filteredPatients={filteredPatients} />
        </TabsContent>
      </Tabs>
    );
  }

  // For staff and admin, show all patients in one table (no tabs)
  return <PatientQueue status="all" filteredPatients={filteredPatients} />;
}
